import * as actions from './actions';


export default (state = {}, action) => {
  switch (action.type) {
    case actions.INIT.END:
      return {
        ...state,
        defaultStatusId: action.defaultStatusId,
      };
    case actions.SET_STATUSES.BEGIN:
      return {
        ...state,
        statuses: action.statuses,
      };
    case actions.SET_STATUSES.END:
      return {
        ...state,
        initialStatus: {
          ...action.initialStatus,
        },
        flowStatuses: action.flowStatuses,
        completedStatuses: action.completedStatuses,
      };
    case actions.SET_DEFAULT_STATUS:
      return {
        ...state,
        defaultStatusId: action.statusId,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ../redux/store/configuration/project/editor/itemType/currentItem/statusFlow/reducer.js